import {styled} from "@mui/styles";

export const TabsContainer = styled("div")({
    height: "fit-content",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: "16px",
    borderBottom: "0.5px solid #e0e0e0",
});
